/* +one · You Are Not Alone — interacciones de la home y del pack */
(() => {
  const qs = (el, s) => el.querySelector(s);
  const qsa = (el, s) => Array.from(el.querySelectorAll(s));

  /* ---- Añadir a la cesta usando las acciones estándar del tema ---- */
  async function addLines(lines) {
    const actions = window.Shopify && window.Shopify.actions;
    if (actions && typeof actions.updateCart === 'function') {
      const res = await actions.updateCart({
        lines: lines.map((l) => ({
          merchandiseId: `gid://shopify/ProductVariant/${l.id}`,
          quantity: l.quantity || 1,
          attributes: l.properties
            ? Object.entries(l.properties).map(([key, value]) => ({ key, value: String(value) }))
            : undefined,
        })),
      });
      if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      try {
        if (typeof actions.openCart === 'function') await actions.openCart();
      } catch (e) {
        /* sin cajón: no pasa nada */
      }
      return res;
    }
    const r = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: lines.map((l) => ({ id: l.id, quantity: l.quantity || 1, properties: l.properties })) }),
    });
    const data = await r.json();
    if (!r.ok || data.status) throw new Error(data.description || data.message || 'No se pudo añadir');
    window.location.href = '/cart';
    return data;
  }

  /* ---- Pestañas de colección ---- */
  function initTabs(root) {
    const tabs = qsa(root, '[role="tab"]');
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i));
      tab.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        select(n);
        tabs[n].focus();
      });
    });
    function select(n) {
      tabs.forEach((t, i) => {
        const on = i === n;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    }
  }

  /* ---- Selector de variante (tarjetas y pack) ---- */
  function makePicker(root, variants, onChange) {
    const groups = qsa(root, '[data-y-option]');
    const chosen = groups.map(() => null);
    const firstAvail = variants.find((v) => v.available) || variants[0];

    groups.forEach((g, gi) => {
      const chips = qsa(g, '.y-chip');
      const label = (qs(g, '.y-picker__label') || {}).textContent || '';
      if (chips.length === 1) chosen[gi] = chips[0].dataset.value;
      else if (/color|colour/i.test(label) && firstAvail) chosen[gi] = firstAvail.options[gi];
      chips.forEach((c) => {
        c.addEventListener('click', () => {
          chosen[gi] = c.dataset.value;
          render();
        });
      });
    });

    function match() {
      if (chosen.some((v) => v === null)) return null;
      return variants.find((v) => v.options.every((o, i) => o === chosen[i])) || null;
    }

    function render() {
      groups.forEach((g, gi) => {
        qsa(g, '.y-chip').forEach((c) => {
          const val = c.dataset.value;
          c.setAttribute('aria-pressed', chosen[gi] === val ? 'true' : 'false');
          const possible = variants.some(
            (v) => v.available && v.options[gi] === val && v.options.every((o, i) => i === gi || chosen[i] === null || o === chosen[i])
          );
          c.disabled = !possible;
          if (!possible && chosen[gi] === val) chosen[gi] = null;
        });
      });
      onChange(match());
    }

    render();
    return { current: match, reset() { render(); } };
  }

  /* ---- "+ Una para regalar" ---- */
  function initCard(card) {
    const toggle = qs(card, '[data-y-gift]');
    const picker = qs(card, '[data-y-picker]');
    if (!toggle || !picker) return;
    const variants = JSON.parse(qs(picker, '[data-y-variants]').textContent);
    const add = qs(picker, '[data-y-add]');
    const msg = qs(picker, '[data-y-msg]');
    let variant = null;

    const p = makePicker(picker, variants, (v) => {
      variant = v;
      add.disabled = !v || !v.available;
      msg.textContent = '';
    });

    toggle.addEventListener('click', () => {
      const open = picker.hidden;
      picker.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) p.reset();
    });

    add.addEventListener('click', async () => {
      if (!variant) return;
      add.disabled = true;
      msg.textContent = 'Añadiendo…';
      try {
        await addLines([{ id: variant.id, quantity: 1 }]);
        msg.textContent = 'Añadida a la cesta.';
        picker.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      } catch (e) {
        msg.textContent = e.message || 'No se pudo añadir. Inténtalo de nuevo.';
      } finally {
        add.disabled = false;
      }
    });
  }

  /* ---- Ediciones con historia ---- */
  function initEditions(root) {
    const slides = qsa(root, '[data-y-slide]');
    if (slides.length < 2) return;
    let i = 0;
    const go = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((s, k) => {
        s.classList.toggle('is-active', k === i);
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
      });
      qsa(root, '[data-y-dot]').forEach((d) => d.setAttribute('aria-current', Number(d.dataset.yDot) === i ? 'true' : 'false'));
    };
    qsa(root, '[data-y-dot]').forEach((d) => d.addEventListener('click', () => go(Number(d.dataset.yDot))));
    qsa(root, '[data-y-next]').forEach((b) => b.addEventListener('click', () => go(i + 1)));
  }

  /* ---- Página del pack ---- */
  function initPackBuilder(root) {
    const catalog = JSON.parse(qs(root, '[data-y-catalog]').textContent).filter(Boolean);
    const cfg = JSON.parse(qs(root, '[data-y-config]').textContent);
    const sizeBtns = qsa(root, '[data-y-size]');
    const slots = qsa(root, '[data-y-slot]');
    const totalEl = qs(root, '[data-y-total]');
    const status = qs(root, '[data-y-status]');
    const addBtn = qs(root, '[data-y-addpack]');
    const params = new URLSearchParams(window.location.search);
    let n = Number(params.get('n')) === 2 ? 2 : Number(params.get('n')) === 3 ? 3 : cfg.default_n;
    const state = slots.map(() => ({ product: null, variant: null }));

    const money = (cents) =>
      (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €';

    function renderOptions(slotEl, idx) {
      const s = state[idx];
      const box = qs(slotEl, '[data-y-opts]');
      box.innerHTML = '';
      if (!s.product) return;
      s.product.options.forEach((opt, oi) => {
        const g = document.createElement('div');
        g.dataset.yOption = String(oi);
        g.innerHTML = `<p class="y-picker__label">${opt.name}</p><div class="y-chips">${opt.values
          .map((v) => `<button type="button" class="y-chip" aria-pressed="false" data-value="${v.replace(/"/g, '&quot;')}">${v}</button>`)
          .join('')}</div>`;
        box.appendChild(g);
      });
      makePicker(box, s.product.variants, (v) => {
        s.variant = v;
        update();
      });
    }

    slots.forEach((slotEl, idx) => {
      qsa(slotEl, '[data-y-design]').forEach((btn) => {
        btn.addEventListener('click', () => {
          qsa(slotEl, '[data-y-design]').forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
          state[idx].product = catalog.find((p) => String(p.id) === btn.dataset.yDesign) || null;
          state[idx].variant = null;
          renderOptions(slotEl, idx);
          update();
        });
      });
    });

    sizeBtns.forEach((b) =>
      b.addEventListener('click', () => {
        n = Number(b.dataset.ySize);
        update();
      })
    );

    function update() {
      sizeBtns.forEach((b) => b.setAttribute('aria-pressed', Number(b.dataset.ySize) === n ? 'true' : 'false'));
      slots.forEach((s, i) => (s.hidden = i >= n));
      const active = state.slice(0, n);
      const ready = active.every((s) => s.variant && s.variant.available);
      const regular = active.reduce((t, s) => t + (s.variant ? s.variant.price : s.product ? s.product.price : cfg.unit_price), 0);
      const packPrice = cfg.prices[String(n)];
      totalEl.innerHTML = packPrice
        ? `<strong>${money(packPrice)}</strong><s>${money(regular)}</s>`
        : `<strong>${money(regular)}</strong>`;
      addBtn.disabled = !ready;
      const missing = active.filter((s) => !s.variant).length;
      status.textContent = ready ? '' : `Te falta elegir ${missing === 1 ? '1 camiseta' : missing + ' camisetas'} (mensaje, color y talla).`;
    }

    addBtn.addEventListener('click', async () => {
      const lines = state.slice(0, n).map((s) => ({ id: s.variant.id, quantity: 1, properties: cfg.property ? { [cfg.property]: cfg.pack_name } : undefined }));
      addBtn.disabled = true;
      status.textContent = 'Añadiendo tu pack…';
      try {
        await addLines(lines);
        status.textContent = 'Pack añadido a la cesta.';
      } catch (e) {
        status.textContent = e.message || 'No se pudo añadir. Inténtalo de nuevo.';
      } finally {
        addBtn.disabled = false;
      }
    });

    update();
  }

  function init(scope) {
    qsa(scope, '[data-y-tabs]').forEach(initTabs);
    qsa(scope, '[data-y-card]').forEach(initCard);
    qsa(scope, '[data-y-editions]').forEach(initEditions);
    qsa(scope, '[data-y-packbuilder]').forEach(initPackBuilder);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* +one · You Are Not Alone — botón "Volver arriba" con anillo de progreso */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  if (document.querySelector('.y-totop')) return;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const RING = 2 * Math.PI * 24;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'y-totop';
  btn.setAttribute('aria-label', 'Volver arriba');
  btn.innerHTML =
    '<svg class="y-totop__ring" viewBox="0 0 52 52" aria-hidden="true"><circle class="y-totop__track" cx="26" cy="26" r="24"/><circle class="y-totop__bar" cx="26" cy="26" r="24"/></svg>' +
    '<svg class="y-totop__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5.5 11.5 12 5l6.5 6.5"/></svg>';
  const mount = () => {
    document.body.appendChild(btn);
    const bar = btn.querySelector('.y-totop__bar');
    bar.style.strokeDasharray = String(RING);
    let ticking = false;
    const update = () => {
      ticking = false;
      const y = window.scrollY || document.documentElement.scrollTop;
      const max = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      btn.classList.toggle('is-visible', y > Math.min(600, max * 0.5) && max > window.innerHeight * 0.6);
      bar.style.strokeDashoffset = String(RING * (1 - Math.min(1, y / max)));
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    btn.addEventListener('click', () => {
      btn.classList.remove('is-flying');
      void btn.offsetWidth;
      btn.classList.add('is-flying');
      window.scrollTo({ top: 0, behavior: reduce.matches ? 'auto' : 'smooth' });
      const target = document.querySelector('#MainContent') || document.body;
      if (target && target.focus) {
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
})();
